
import './Disclaimer.css'
import Navigationbar from '../header/Navigationbar'
import Footer from '../footer/Footer'
import { useEffect } from 'react';

const Disclaimer=()=> {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Navigationbar />
      <div className='container mt-4 mb-4'>
        <br/>
        <br/>
        <div className='disclaimer-main'>
          <h1 className='disclaimer-text'>Disclaimer for Currency Growth Financial Service</h1>
          <p className='disclaimer-text'>If you require any more information or have any questions about our site's disclaimer, please feel free to contact us by email at contact@cgfs.co.in.</p>
          <h2 className='disclaimer-text'>Disclaimers for Currency Growth Financial Service</h2>
          <p className='disclaimer-text'>All the information on this website - https://cgfs.co.in/ - is published in good faith and for general information purpose only. Currency Growth Financial Service does not make any warranties about the completeness, reliability and accuracy of this information. Any action you take upon the information you find on this website (Currency Growth Financial Service), is strictly at your own risk. Currency Growth Financial Service will not be liable for any losses and/or damages in connection with the use of our website.</p>
          <p className='disclaimer-text'>From our website, you can visit other websites by following hyperlinks to such external sites. While we strive to provide only quality links to useful and ethical websites, we have no control over the content and nature of these sites. These links to other websites do not imply a recommendation for all the content found on these sites. Site owners and content may change without notice and may occur before we have the opportunity to remove a link which may have gone 'bad'.</p>
          <p className='disclaimer-text'>Please be also aware that when you leave our website, other sites may have different privacy policies and terms which are beyond our control. Please be sure to check the Privacy Policies of these sites as well as their "Terms of Service" before engaging in any business or uploading any information.</p>
          <h2 className='disclaimer-text'>Consent</h2>
          <p className='disclaimer-text'>By using our website, you hereby consent to our disclaimer and agree to its terms.</p>
          <h2 className='disclaimer-text'>Update</h2>
          <p className='disclaimer-text'>Should we update, amend or make any changes to this document, those changes will be prominently posted here.</p>
        </div>
        </div>
      <Footer />
    </>
  )
}
export default Disclaimer